import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';

import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { MenuComponent } from './pages/menu/menu.component';
import { OrderComponent } from './pages/order/order.component';
import { OrderlstComponent } from './pages/orderlst/orderlst.component';
import { ItemCreateComponent } from './pages/item-create/item-create.component';
import { UserComponent } from './pages/user/user.component';
import { SignUpComponent } from './pages/user/sign-up/sign-up.component';
import { SignInComponent } from './pages/user/sign-in/sign-in.component';
import { TodayOrderListComponent } from './pages/today-order-list/today-order-list.component';
import { UserOrderListComponent } from './pages/user-order-list/user-order-list.component';
import { AdminGuard } from './guards/admin.guard';
import { AuthorizeComponent } from './pages/user/sign-in/authorize.component';
import { LogoutComponent } from './pages/user/sign-in/logout.component';
import { UserListComponent } from './pages/user/user-list.component';
import {SettingComponent} from './pages/setting/setting.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent,
        children: [
          { path: '', redirectTo: 'menu', pathMatch: 'full' },
          { path: 'menu', component: MenuComponent },
          { path: 'my-order', component: OrderlstComponent },
          { path: 'add-order', component: OrderComponent },
          { path: 'today/order/list', component: TodayOrderListComponent },
          { path: 'add/order/:id', component: OrderComponent },
          { path: 'edit/order/:orderId/:id', component: OrderComponent },
          { path: 'manage/item', component: ItemCreateComponent, canActivate: [AdminGuard] },
          { path: 'manage/user/order', component: UserOrderListComponent, canActivate: [AdminGuard] },
          { path: 'manage/user/setting', component: SettingComponent, canActivate: [AdminGuard] },
          { path: 'manage/users', component: UserListComponent, canActivate: [AdminGuard] },
        ]
      }
    ]
  },
  {
    path: 'signup',
    component: UserComponent,
    children: [{ path: '', component: SignUpComponent }]
  },
  {
    path: 'login',
    component: UserComponent,
    children: [{ path: '', component: SignInComponent }]
  },
  {
    path: 'authorize',
    component: AuthorizeComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  { path: '**', component: HomeComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts